import { render, staticRenderFns } from "./procedures-item.vue?vue&type=template&id=70ba5503"
import script from "./procedures-item.vue?vue&type=script&lang=js"
export * from "./procedures-item.vue?vue&type=script&lang=js"
import style0 from "./procedures-item.vue?vue&type=style&index=0&id=70ba5503&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports